enum APPOINTMENT_TYPES {
  SET_APPOINTMENT_FORM_VAL = 'SET_APPOINTMENT_FORM_VAL',
  SET_OPTION = 'SET_OPTION',
  GET_SUB_CATEGORIES = 'GET_SUB_CATEGORIES',
  SUB_CATEGORIES_DATA = 'SUB_CATEGORIES_DATA',
  SET_SUB_CATEGORY_OPTION = 'SET_SUB_CATEGORY_OPTION',
  GET_TIME_SLOTS = 'GET_TIME_SLOTS',
  SET_TIME_SLOTS = 'SET_TIME_SLOTS',
  SET_APPOINTMENT_DATE = 'SET_APPOINTMENT_DATE',
  SUBMIT_FORM = 'SUBMIT_FORM',
}
export default APPOINTMENT_TYPES;
